var headerDesktopWidget;

(function() {
    'use strict';
    if (!document.querySelector('#vue-header')) {
        return;
    }

    headerDesktopWidget = new Vue({
        el: '#vue-header',

        data: function() {
            return {
                scrollOffsetHidden: 300,
                scrollOffset: 100,
                scrolling: false,
                scrollDelta: 10,
                previousTop: 0,
                currentTop: 0,

                currentItem: null,

                notificationsBadge: null,
                allNotificationsBadge: null,
                notificationsInterval: null,
                notificationsIntervalGap: NEW_CONTENT_NOTIFICATION_REFRESH_INTERVAL,
                initialNotifications: 0,
                totalNotifications: 0,

                initialized: false,
            };
        },

        computed: {
            totalNotificationsFormatted: function() {
                return (this.totalNotifications >= 99) ? '+99' : this.totalNotifications;
            }
        },

        methods: {

            onScroll: function() {
                var mainHeader = document.querySelector('.js-header');

                this.currentTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

                // Manage .header--mini class
                if (this.currentTop <= this.scrollOffset) {
                    mainHeader.classList.remove('header--mini');
                } else {
                    mainHeader.classList.add('header--mini');
                }

                // Manage .header--hidden class
                // if ((this.previousTop - this.currentTop) > this.scrollDelta) {
                //     //if scrolling up...
                //     mainHeader.classList.remove('header--hidden');
                // } else if ((this.currentTop - this.previousTop) > this.scrollDelta && this.currentTop > this.scrollOffsetHidden) {
                //     //if scrolling down...
                //     mainHeader.classList.add('header--hidden');
                // }

                this.previousTop = this.currentTop;
                this.scrolling = false;
            },

            initScroll: function() {
                var _this = this;

                window.addEventListener('scroll', function() {
                    if (_this.scrolling) {
                        return;
                    }

                    _this.scrolling = true;

                    if (!window.requestAnimationFrame) {
                        setTimeout(_this.onScroll, 250);
                    } else {
                        requestAnimationFrame(_this.onScroll);
                    }
                });
            },

            toggleMegamenu: function(ev) {
                if (this.currentItem) {
                    this.currentItem.classList.remove('main-nav__item--open');
                }

                if (this.currentItem === ev.target.parentElement) {
                    this.currentItem = null;
                    return;
                }

                this.currentItem = ev.target.parentElement;
                this.currentItem.classList.add('main-nav__item--open');
            },

            onNotificationsLoaded: function(response) {
                if (response.status !== 200) {
                    return;
                }

                var data = response.data;

                if ((typeof data !== 'object') || (data.result !== 'OK') || !data.unreadNewContent) {
                    // REVIEW: en la versión responsive se ha omitido el control
                    // de sesión en este punto con la llamada a sessionExpired
                    return;
                }

                var privateBadge = document.querySelector('.js-user-popup a[data-tag="USER_home"] .js-notifications-badge');

                privateBadge.classList.remove('d-none');
                privateBadge.setAttribute('data-notifications', data.unreadNewContent);
                privateBadge.innerText = '('+data.unreadNewContent+')';

                this.totalNotifications = this.initialNotifications + parseInt(data.unreadNewContent);
            },

            getNewContentNotifications: function() {
                axios
                    .post('/content/getNewContentSinceUserLogin')
                    .then(this.onNotificationsLoaded)
                    .catch(function(error) {
                        console.log(error);
                    });
            },

            initUserProfile: function() {
                var _this = this;

                this.notificationsBadge = this.$refs.notificationsBadge;
                this.allNotificationsBadge = this.$refs.allNotificationsBadge;

                this.initialNotifications = (this.allNotificationsBadge) ? parseInt(this.allNotificationsBadge.getAttribute('data-badge')) : 0;
                this.totalNotifications = this.initialNotifications;

                this.notificationsInterval = setInterval(function() {
                    _this.getNewContentNotifications();
                }, this.notificationsIntervalGap);

                this.getNewContentNotifications();
            },

            init: function() {
                if (this.initialized) {
                    return;
                }

                this.initialized = true;
                this.initScroll();
            },
        },

        mounted: function() {
            this.init();
            this.initUserProfile();
        },

        updated: function() {
            if (!this.initialized) {
                this.init();
            }
        },
    });
})();
